import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentsService {

  constructor(
    private _http: HttpClient
  ) { }

  getSubscriptions() {
    return this._http.get(`${environment.url}/payments/subscriptions`)
  }

  createPaymentSession(payload: any) {
    return this._http.post(`${environment.url}/payments/session`, payload)
  }

  createPaymentIntent(payload: any) {
    return this._http.post(`${environment.url}/payments/paymentIntent`, payload)
  }

  cancelSubscription(id: string) {
    return this._http.delete(`${environment.url}/payments/subscription/${id}`)
  }

  changeSubscription(payload: any) {
    return this._http.put(`${environment.url}/payments/subscription`, payload)
  }

  getChangedSubscriptionInvoice(payload: any) {
    return this._http.post(`${environment.url}/payments/invoice/latest`, payload)
  }

  getAllSubscriptions() {
    return this._http.get(`${environment.url}/payments/subscriptions/all`)
  }

  cancelUpcomingSubscription(id: string, payload) {

    return this._http.delete(`${environment.url}/payments/subscription/upcoming/${id}`, { params: payload });
  }

  updateUpcomingSubscription(id: string, payload: any) {
    return this._http.put(`${environment.url}/payments/subscription/upcoming/${id}`, payload);
  }

  createUpcomingSubscription(payload: any) {
    return this._http.post(`${environment.url}/payments/subscription/upcoming`, payload);
  }

  cancelSubscriptionImmediatelyAndRefund(id: string) {
    return this._http.delete(`${environment.url}/payments/subscription/${id}/refund`);
  }
}
